import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth';

/** Assumes authGuard already ran first (canActivate: [authGuard, siteAdminGuard])
 *  — a signed-in but non-admin user is redirected to /competitions, not /login. */
export const siteAdminGuard: CanActivateFn = () => {
  const auth = inject(AuthService);
  const router = inject(Router);
  return auth.user()?.siteRole === 'SITE_ADMIN' ? true : router.createUrlTree(['/competitions']);
};
